import React from 'react';
import SentimentIcon from './SentimentIcon';

const SentimentDetail = ({ score }) => (
  <>
    <span className="me-1">
      <SentimentIcon sentiment={score} size="lg" />
    </span>
    {score ? (
      <span className="text-capitalize">
        {score.toLowerCase()}
      </span>
    ) : (
      'Sentiment score not available.'
    )}
  </>
);

export default SentimentDetail;
